define(function (require) {
    $ = require("jquery");
    require("amcharts.serial");
    require("amcharts.xy");
    require("amcharts.fr");
    var i18n = require("i18n");
    require("amcharts.plugins.export");

    $(function () {
        initChart();

        $("#panelNuagePoints").click(function () {
            $("#modalNuageFondsVsCategorie").modal("show");
        })
    });

    function initChart() {
        // Fond vs Cat (nuage de points)
        initChartFvsC(1);
        initChartFvsC(3);
        initChartFvsC(5);
    }

    function initChartFvsC(year) {
        var $inputChartConfigFvsC = $("#chartFondVsCat" + year + "a [data-chartconfig]");
        var jsonConfig = $inputChartConfigFvsC.val();
        if (jsonConfig != null && jsonConfig !== "") {
            var amChartConfigFvsC = JSON.parse(jsonConfig);

            //export
            var hasExportCharts = $("#hasExportCharts").val();
            if (hasExportCharts === "true") {
                amChartConfigFvsC.export = {
                    enabled: true,
                    fileName: $("#produitsNom").val()
                }
            }

            //Ajout des % au balloon pour la performance et la volatilité
            for (var i = 0; i < amChartConfigFvsC.graphs.length; i++) {
                amChartConfigFvsC.graphs[i].balloonText = "[[title]]<br/> " + i18n.performance + " : [[y]]%<br />" + i18n.volatilite + " : [[x]]%";
            }
            

            $inputChartConfigFvsC.remove();
            AmCharts.makeChart("chartFondVsCat" + year + "a", amChartConfigFvsC);

            var amChartConfigModal = JSON.parse(jsonConfig);
            //amChartConfigModal.graphs[0].urlField = "url3";

            ////Ajout des % au balloon pour la performance et la volatilité
            //for (var i = 0; i < amChartConfigModal.graphs.length; i++) {
            //    amChartConfigModal.graphs[i].balloonText = "[[title]]<br/> " + i18n.performance + " : [[y]]%<br />" + i18n.volatilite + " : [[x]]%";
            //}

            if (hasExportCharts === "true") {
                amChartConfigModal.export = {
                    enabled: true,
                    fileName: $("#produitsNom").val()
                }
            }

            AmCharts.makeChart("chartFondVsCatModal" + year + "a", amChartConfigModal);
        }
        else {
            $("#chartFondVsCat [data-error]").removeClass("hidden");
            $("#chartFondVsCatModal [data-error]").removeClass("hidden");
        }
    }
});
